// This file is auto-generated and contains a map with all design-tokens in @tdcerhverv/parrotfish
$color-roman-80: rgba(168, 59, 59, 1);
$color-roman-50: rgba(221, 94, 94, 1);
$color-roman-40: rgba(237, 109, 109, 1);
$color-roman-30: rgba(248, 223, 223, 1);
$color-brightsun-80: rgba(135, 100, 19, 1);
$color-brightsun-50: rgba(241, 188, 38, 1);
$color-brightsun-40: rgba(251, 207, 62, 1);
$color-brightsun-30: rgba(254, 245, 216, 1);
$color-danube-80: rgba(46, 107, 140, 1);
$color-danube-50: rgba(102, 173, 211, 1);
$color-danube-40: rgba(124, 193, 230, 1);
$color-danube-30: rgba(224, 239, 246, 1);
$color-breakerbay-80: rgba(31, 111, 91, 1);
$color-breakerbay-50: rgba(80, 160, 141, 1);
$color-breakerbay-40: rgba(105, 180, 162, 1);
$color-breakerbay-30: rgba(220, 236, 232, 1);
$color-grey-80: rgba(71, 78, 83, 1);
$color-grey-64: rgba(108, 114, 117, 1);
$color-grey-48: rgba(145, 149, 152, 1);
$color-grey-32: rgba(181, 184, 186, 1);
$color-grey-16: rgba(218, 220, 221, 1);
$color-grey-8: rgba(241, 241, 242, 1);
$color-mirage: rgba(25, 34, 40, 1);
$color-white: rgba(255, 255, 255, 1);
$color-shamrock-40: rgba(58, 229, 187, 1);
$color-shamrock-60: rgba(48, 191, 155, 1);
$color-dixie-60: rgba(229, 141, 23, 1);
$color-dixie-40: rgba(255, 191, 26, 1);
$color-cerulean-blue-20: rgba(45, 128, 211, 1);
$color-cerulean-blue-40: rgba(38, 107, 175, 1);
$color-cerulean-blue-60: rgba(0, 75, 146, 1);
$theme: (
  'error-dark': $color-roman-80,
  'error': $color-roman-50,
  'error-medium-light': $color-roman-40,
  'error-light': $color-roman-30,
  'warning-dark': $color-brightsun-80,
  'warning': $color-brightsun-50,
  'warning-medium-light': $color-brightsun-40,
  'warning-light': $color-brightsun-30,
  'info-dark': $color-danube-80,
  'info': $color-danube-50,
  'info-medium-light': $color-danube-40,
  'info-light': $color-danube-30,
  'success-dark': $color-breakerbay-80,
  'success': $color-breakerbay-50,
  'success-medium-light': $color-breakerbay-40,
  'success-light': $color-breakerbay-30,
  'grey-darkest': $color-grey-80,
  'grey-dark': $color-grey-64,
  'grey-medium-dark': $color-grey-48,
  'grey-medium-light': $color-grey-32,
  'grey-light': $color-grey-16,
  'grey-lightest': $color-grey-8,
  'black': $color-mirage,
  'white': $color-white,
  'accent': $color-shamrock-40,
  'accent-dark': $color-shamrock-60,
  'secondary-dark': $color-dixie-60,
  'secondary': $color-dixie-40,
  'primary-light': $color-cerulean-blue-20,
  'primary': $color-cerulean-blue-40,
  'primary-dark': $color-cerulean-blue-60,
);
